module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [(_vm.campaign) ? _c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("Change Campaign Status")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "body-2"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "xs": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Current Status",
      "filled": "",
      "disabled": "",
      "value": _vm.displayStatus(_vm.campaign.status)
    }
  })], 1), _vm._v(" "), _c('v-icon', [_vm._v("mdi-arrow-right-thick")]), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.status_options,
      "item-text": "display",
      "item-value": "status",
      "menu-props": {
        maxHeight: '400'
      },
      "label": "New Status",
      "filled": "",
      "hint": "Select new Campaign Status",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.selectedStatus),
      callback: function($$v) {
        _vm.selectedStatus = $$v
      },
      expression: "selectedStatus"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "text": "",
      "disabled": _vm.selectedStatus === _vm.campaign.status
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus()
      }
    }
  }, [_vm._v("Save")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('update-campaign-quarter-modal', {
    attrs: {
      "value": _vm.campaignQuarterDialog,
      "campaignID": _vm.viewCampaignId,
      "multipleCampaignIds": _vm.multipleCampaignIds
    },
    on: {
      "updated": _vm.closeModal
    },
    model: {
      value: (_vm.campaignQuarterDialog),
      callback: function($$v) {
        _vm.campaignQuarterDialog = $$v
      },
      expression: "campaignQuarterDialog"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-81d21502"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/ChangeCampaignStatusModal.vue
// module id = 2227
// module chunks = 0